export default __webpack_public_path__ + "static/media/github.47d85141.png";